import React, { useState, useEffect } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
// import { Link } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import AuthInput from "../../../shared/authinput";
import MainButton from "../../../shared/Button";
import {
  ChangePasswordMain,
  FormMain,
  IconButtonMain,
  LinkMain,
  ChangePasswordForm,
} from "../styles/ProfileChangePasswordStyle";
import { ProfilePasswordvalidation } from "../../../../helpers/validations/Auth";
import { Button } from "@mui/material";
import { signouthandler } from "../../../../services/auth/logout";
import { useDispatch } from "react-redux";
import {
  clearAuthStorage,
  setRedirTo,
} from "../../../../redux/slice/user/UserSlice";
import { toast } from "react-hot-toast";
import httpRequest from "../../../../axios/index";
import { UPDATEPASSWORD } from "../../../../constants/apiEndPoints";

const ProfileChangePassword = () => {
  // const myInput = document.getElementById("password");
  const [Loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [CurrentPassword, setCurrentPassword] = useState("");

  // const [addNewClass, setaddNewClass] = useState(null);

  const dispatch = useDispatch();
  const handleTogglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const passwordChangeHandler = (value) => {
    const requirements = {
      letter: document.getElementById("letter"),
      capital: document.getElementById("capital"),
      symbol_or_number: document.getElementById("symbol_or_number"),
      length: document.getElementById("length"),
    };
    const validations = {
      letter: /[a-z]/g,
      capital: /[A-Z]/g,
      symbol_or_number: /(?=.*?[0-9!@#$%^&*])/g,
      length: /^.{8,}$/g,
    };

    Object.keys(requirements).forEach((key) => {
      const requirement = requirements[key];
      const isValid = value?.match(validations[key]);
      if (isValid) {
        requirement?.classList?.remove("invalid");
        requirement?.classList?.add("valid");
      } else {
        requirement?.classList?.remove("valid");
        requirement?.classList?.add("invalid");
      }
    });
  };

  const handleForgotPasswordClick = async () => {
    const res = await signouthandler();
    if (res.status === 200) {
      dispatch(setRedirTo("/forgot-password"));
      dispatch(clearAuthStorage());
    }
  };

  const handleSubmit = async (values, { resetForm }) => {
    if (!CurrentPassword) {
      toast.error("Current Password is required");
      return;
    }

    const userObj = {
      current_password: CurrentPassword,
      password: values.newPassword,
    };

    try {
      setLoading(true);
      const resp = await httpRequest.patch(UPDATEPASSWORD, {
        user: userObj,
      });

      if (resp?.status === 200) {
        resetForm();
        toast.success(resp?.data?.message);
        setCurrentPassword("");
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        (error?.response?.data?.message || "Something went wrong").replace(
          "Validation failed: ",
          ""
        )
      );
      setLoading(false);
    }
  };

  return (
    <ChangePasswordMain>
      <FormMain>
        <div className="inputsMain">
          <label htmlFor="CurrentPassword">Current Password</label>
          <input
            id="CurrentPassword"
            type={showPassword ? "text" : "password"}
            value={CurrentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
          />
          <IconButtonMain
            className="iconButton"
            onClick={handleTogglePassword}
            size="small"
          >
            {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
          </IconButtonMain>
        </div>
      </FormMain>
      <LinkMain>
        <Button onClick={handleForgotPasswordClick}>Forgot Password?</Button>
      </LinkMain>
      <ChangePasswordForm>
        <Formik
          initialValues={{ newPassword: "", confirmPassword: "" }}
          validationSchema={ProfilePasswordvalidation}
          onSubmit={handleSubmit}
        >
          {(formik) => (
            <Form autocomplete="off">
              <Field
                type="password"
                name="newPassword"
                label="New Password"
                component={AuthInput}
                placeholder="Enter your password"
                showIcon={true}
                onChange={(e) => {
                  formik.handleChange(e);
                  passwordChangeHandler(e.target.value);
                }}
                value={formik.values.newPassword}
              />
              <Field
                type="password"
                name="confirmPassword"
                label="Confirm Password"
                component={AuthInput}
                placeholder="Confirm your password"
                showIcon={true}
              />
              <div className={!formik.values.newPassword && "No_error"}>
                <p id="length" className="invalid">
                  Password must be at least 8 characters long.
                </p>
                <p id="capital" className="invalid">
                  Password must contain at least one upper case.
                </p>
                <p id="letter" className="invalid">
                  One lower case letter.
                </p>
                <p id="symbol_or_number" className="invalid">
                  Password must contain at least one number or special
                  character.
                </p>
              </div>

              <MainButton
                type="submit"
                label="Change Password"
                MT="60"
                isLoading={Loading}
              />
            </Form>
          )}
        </Formik>
      </ChangePasswordForm>
    </ChangePasswordMain>
  );
};

export default ProfileChangePassword;
